import React, { ReactNode } from "react";

import "./content.scss";

interface Props {
  children?: ReactNode;
  style?: React.CSSProperties;
  // any props that come into the component
}

const Content = ({ children, style }: Props) => {
  return (
    <div className='content' style={style}>
      {children}
    </div>
  );
};

export default Content;
